
































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { EditorState } from '@/types/editor';

@Component
export default class CategoryMetaDataInput extends Vue {
  @Prop() category!: EditorState;

  @Mutation('categories/setCategoryMetaTitle') setCategoryMetaTitle!: Function;
  @Mutation('categories/setCategoryMetaDescription')
  setCategoryMetaDescription!: Function;
  @Mutation('categories/setCategoryCanonicalUrl')
  setCategoryCanonicalUrl!: Function;
  @Mutation('categories/setCategoryTwitterTitle')
  setCategoryTwitterTitle!: Function;
  @Mutation('categories/setCategoryTwitterDescription')
  setCategoryTwitterDescription!: Function;
  @Mutation('categories/setCategoryOpenGraphTitle')
  setCategoryOpenGraphTitle!: Function;
  @Mutation('categories/setCategoryOpenGraphDescription')
  setCategoryOpenGraphDescription!: Function;

  get meta_title() {
    return this.category.meta!.meta_title;
  }
  set meta_title(value) {
    this.setCategoryMetaTitle(value);
  }
  get meta_description() {
    return this.category.meta!.meta_description;
  }
  set meta_description(value) {
    this.setCategoryMetaDescription(value);
  }
  get canonical_url() {
    return this.category.meta!.canonical_url;
  }
  set canonical_url(value) {
    this.setCategoryCanonicalUrl(value);
  }

  get twitter_title() {
    return this.category.meta!.twitter_title;
  }
  set twitter_title(value) {
    this.setCategoryTwitterTitle(value);
  }
  get twitter_description() {
    return this.category.meta!.twitter_description;
  }
  set twitter_description(value) {
    this.setCategoryTwitterDescription(value);
  }

  get open_graph_title() {
    return this.category.meta!.open_graph_title;
  }
  set open_graph_title(value) {
    this.setCategoryOpenGraphTitle(value);
  }
  get open_graph_description() {
    return this.category.meta!.open_graph_description;
  }
  set open_graph_description(value) {
    this.setCategoryOpenGraphDescription(value);
  }
}
